import { useState, useEffect, useRef, useContext } from "react";
import { Link } from "react-router-dom";
import { GET_TABLE_BOOKING_TIME, POST_BOOK_TABLE, GET_TABLE_BOOK_DETAIL, POST_CHECK_AVAILABLE_TABLE } from '../../helpers/url_helper';
import { is_login, img_view } from '../../helpers/Helper';
import { post, get } from '../../helpers/api_helper';
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import { useHistory } from "react-router-dom";
import { MenuContext } from '../../layouts/Default';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import { addMonths } from 'date-fns';
import Moment from 'moment';
import Close from "@material-ui/icons/Close";
import OpenTableWidget from "../../component/OpenTableWidget";
const StripeCheckout2 = require('react-stripe-checkout').default;

const modalStyles = `
  .widget-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .widget-modal-content {
    background: white;
    padding: 25px;
    border-radius: 8px;
    position: relative;
  }
  .widget-modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    background: #f1f1f1;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    cursor: pointer;
    font-weight: bold;
    font-size: 16px;
    line-height: 30px;
  }
`;


export default function Home(props) {
    let history = useHistory();
    const { menu, minimum_person_save_card_details } = useContext(MenuContext);

    const [BookingDetail, setBookingDetail] = useState({ booking_no: '', booking_type: 'Table Booking', seating_type: 'Indoor', date: '', time: '', first_name: '', last_name: '', number_of_people: '', phone_number: '', email: '', post_code: '', note: '', customer_id: '', tc: true });
    const [dateList, setDateList] = useState([]);
    const [timeList, setTimeList] = useState([]);
    const [PartySize, setPartySize] = useState(0);
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [indoorAvailability, setIndoorAvailability] = useState(null);
    const [outdoorAvailability, setOutdoorAvailability] = useState(null);
    const [showBookingWidget, setShowBookingWidget] = useState(false);


    const simpleValidator = useRef(new SimpleReactValidator());
    const [, forceUpdate] = useState();
    const [isLoader, setLoader] = useState(0);
    const [ShowTc, SetShowTc] = useState(false);
    const [weekOff, SetWeekOff] = useState(false);

    const [startDate, setStartDate] = useState('');

    useEffect(() => {
        async function get_detaile() {
            var date_res_data = await get(GET_TABLE_BOOKING_TIME);
            if (date_res_data.status) {
                setDateList(date_res_data.data.date_array);
            }

            if (props.match.params.booking_id) {
                var res_data = await post(GET_TABLE_BOOK_DETAIL, { booking_no: props.match.params.booking_id });
                if (res_data.status) {
                    if (res_data.data.booking_detail.status != 'Confirmed') {
                        history.push("/");
                    }
                    setStartDate(new Date(res_data.data.booking_detail.date));
                    BookingDetail.booking_no = res_data.data.booking_detail.booking_no;
                    BookingDetail.date = res_data.data.booking_detail.date;
                    BookingDetail.time = res_data.data.booking_detail.time;
                    res_data.data.booking_detail.tc = true;
                    setBookingDetail(res_data.data.booking_detail);
                    for (var date_value of date_res_data.data.date_array) {
                        if (date_value.date == res_data.data.booking_detail.date) {
                            setTimeList(date_value.time);
                        }
                    }
                    CheckAvailableTable()
                } else {
                    toast.error(res_data.message);
                    history.push("/");
                }
            }
            setLoader(1);
        }
        get_detaile();
    }, [])

    const handleInputChange = (event) => {
        event.persist();
        if (event.target.name == 'date') {
            for (var date_value of dateList) {
                if (date_value.date == event.target.value) {
                    setTimeList(date_value.time);
                }
            }
            BookingDetail.time = '';
            BookingDetail.date = event.target.value;
            BookingDetail.number_of_people = '';

            setBookingDetail(inputs => ({ ...BookingDetail, [event.target.name]: event.target.value }));
            CheckAvailableTable();
        } else if (event.target.name == 'time') {
            BookingDetail.number_of_people = '';
            BookingDetail.time = event.target.value;
            setBookingDetail(inputs => ({ ...BookingDetail, [event.target.name]: event.target.value }));
            CheckAvailableTable();
        } else if (event.target.name === 'seating_type') {
            const newSeatingType = event.target.value;
            setBookingDetail(inputs => ({ ...BookingDetail, seating_type: newSeatingType, number_of_people: '' }));
            if (newSeatingType === 'Indoor') {
                setPartySize(indoorAvailability || 0);
            } else {
                setPartySize(outdoorAvailability || 0);
            }
        } else if (event.target.name === 'tc') {
            setBookingDetail(inputs => ({ ...BookingDetail, [event.target.name]: event.target.checked }));
        } else {
            setBookingDetail(inputs => ({ ...BookingDetail, [event.target.name]: event.target.value }));
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            if (!BookingDetail.tc && (parseInt(BookingDetail.number_of_people) >= minimum_person_save_card_details)) {
                toast.error('Please accept terms and conditions');
                return false;
            }
            SetButtonDisabled(true);
            if (BookingDetail.customer_id || parseInt(BookingDetail.number_of_people) < minimum_person_save_card_details) {
                var res_data = await post(POST_BOOK_TABLE, BookingDetail);
                if (res_data.status) {
                    history.push("/table-booking-success/" + res_data.data.booking_no);
                } else {
                    toast.error(res_data.message);
                }
                SetButtonDisabled(false);
            } else {
                window.$('.StripeCheckout2').click();
                setTimeout(() => {
                    SetButtonDisabled(false);
                }, 5000);
            }

        }
    }

    const CheckAvailableTable = async (event) => {
        if (BookingDetail.date && BookingDetail.time) {
            // Fetch for Indoor
            var indoor_res_data = await post(POST_CHECK_AVAILABLE_TABLE, { id: BookingDetail.booking_no, date: BookingDetail.date, time: BookingDetail.time, seating_type: 'Indoor' });
            const indoorSize = indoor_res_data.status ? indoor_res_data.booking_available : 0;
            setIndoorAvailability(indoorSize);
            if (!indoor_res_data.status) toast.error(indoor_res_data.message);

            // Fetch for Outdoor
            var outdoor_res_data = await post(POST_CHECK_AVAILABLE_TABLE, { id: BookingDetail.booking_no, date: BookingDetail.date, time: BookingDetail.time, seating_type: 'Outdoor' });
            const outdoorSize = outdoor_res_data.status ? outdoor_res_data.booking_available : 0;
            setOutdoorAvailability(outdoorSize);
            if (!outdoor_res_data.status) toast.error(outdoor_res_data.message);

            // Auto-select an available seating type if the current one is full
            let updatedSeatingType = BookingDetail.seating_type;
            if (BookingDetail.seating_type === 'Indoor' && indoorSize === 0 && outdoorSize > 0) {
                updatedSeatingType = 'Outdoor';
                setBookingDetail(inputs => ({ ...inputs, seating_type: 'Outdoor' }));
            } else if (BookingDetail.seating_type === 'Outdoor' && outdoorSize === 0 && indoorSize > 0) {
                updatedSeatingType = 'Indoor';
                setBookingDetail(inputs => ({ ...inputs, seating_type: 'Indoor' }));
            }

            // Set PartySize for the (potentially updated) selected seating type
            if (updatedSeatingType === 'Indoor') {
                setPartySize(indoorSize);
            } else {
                setPartySize(outdoorSize);
            }
        } else {
            setIndoorAvailability(null);
            setOutdoorAvailability(null);
            setPartySize(0);
        }
    }


    const handleToken = async (token, address) => {
        SetButtonDisabled(true);

        // form_inputs.product = product
        BookingDetail.token = token

        const response = await post(POST_BOOK_TABLE, BookingDetail);
        if (response.status) {
            history.push("/table-booking-success/" + response.data.booking_no);
        } else {
            toast.error(response.message);
        }
        SetButtonDisabled(false);
    }

    const setDate = (event) => {
        setStartDate(event);
        var date = new Date(event),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        var new_date = [date.getFullYear(), mnth, day].join("-");

        console.log(new_date);
        if (date.getDay() == 1) {
            SetWeekOff(true);
        } else {
            SetWeekOff(false);
        }
        var today_stop = false;
        if (Moment(new Date()).format('YYYY-MM-DD') == new_date) {
            if (parseInt(Moment(new Date()).format('HHmmss')) > 170000) {
                today_stop = true;
            }
        }
        // format(new Date(), 'yyyy/mm/dd')
        setTimeList([]);
        if (!today_stop) {
            for (var date_value of dateList) {
                if (date_value.date == new_date) {
                    setTimeList(date_value.time);
                }
            }
        }
        BookingDetail.time = '';
        BookingDetail.date = new_date;
        BookingDetail.number_of_people = '';

        setBookingDetail(inputs => ({ ...BookingDetail, ['date']: new_date }));
        CheckAvailableTable();
    }


    return (<>
        <div className="banner_wrapper">
            <div className="innerbanner">
                <div className="imagebox" style={{ "background-image": 'url(/assets/images/innerbanner.jpg)' }}></div>
                <div className="bann_captionbox">
                    <div className="container-fluid">
                        <h1>Book a Table</h1>
                        <div className="opentiming">100% Gluten Free</div>
                    </div>
                </div>
            </div>
        </div>

        <div className="functionbooking_wrap">
            <div className="container">
                <div className="function_title">
                    <h2>Onda Bar and Eatery Reservations</h2>
                </div>
                <div className="function_meta">
                    <div className="callaction"><img src="/assets/images/phone_icon.svg" alt="" />+61 3 9429 8589</div>
                    <div className="callaction"><img src="/assets/images/map_pin_icon_2.svg" alt="" />280 Bridge Rd, Richmond 3121</div>
                </div>
                <div className="justify-content-center d-flex">
                {menu.table_booking_menu && <div className="text-center me-3">
                    <a href={img_view(menu.food_menu, '', '', false)} target="_blank" className="pdf_menu">View Food Menu</a>
                </div>}
                {menu.table_booking_menu && <div className="text-center me-3">
                    <a href={img_view(menu.cocktail_menu, '', '', false)} target="_blank" className="pdf_menu">View Cocktails Menu</a>
                </div>}
                {menu.table_booking_menu && <div className="text-center">
                    <a href={img_view(menu.wines_menu, '', '', false)} target="_blank" className="pdf_menu">View Wines Menu</a>
                </div>}
                </div>
                {BookingDetail.date == '2023-05-14' && <div className="function_form_wrap text-center" style={{ "margin": "-30px auto 40px auto;" }}>
                    <p>Enjoy shared snacks and starters followed by your choice of main plus sides and a special sweet treat to finish. Additional menu items will be available. </p>
                    <p>Please note no a-la-carte dining will be offered on this day.</p>
                </div>}
                {(startDate && !timeList.length && !weekOff) && <p className="text-danger text-center" style={{ 'fontSize': '22px' }}><b>Please call us on <a href="tel:+61 3 9429 8589" className="text-danger">03 9429 8589</a> to book your table</b></p>}
                {(startDate && !timeList.length && weekOff) && <p className="text-danger text-center" style={{ 'fontSize': '22px' }}><b>We are close</b></p>}
                <div className="function_form_wrap">
                    
                    {/* --- NEW MESSAGE BLOCK START --- */}
                    {indoorAvailability !== null && outdoorAvailability !== null && (
                        <div className="text-center mb-3" style={{ fontSize: '18px' }}>
                            {indoorAvailability === 0 && outdoorAvailability === 0 && (
                                <p className="text-danger text-center" style={{ 'fontSize': '22px' }}><b>Please call us on <a href="tel:+61 3 9429 8589" className="text-danger">03 9429 8589</a> to book your table</b></p>
                            )}
                            {indoorAvailability === 0 && outdoorAvailability > 0 && (
                                <p className="text-warning"><b>Indoor is full, please select Outdoor.</b></p>
                            )}
                            {outdoorAvailability === 0 && indoorAvailability > 0 && (
                                <p className="text-warning"><b>Outdoor is full, please select Indoor.</b></p>
                            )}
                        </div>
                    )}
                    {/* --- NEW MESSAGE BLOCK END --- */}

                    <form action="" onSubmit={handleSubmit}>
                        <div className="row">
                            {/* <div className="col-lg-12 mb-3">
                                <div className="form_box">
                                    <label htmlFor="">Seating Preference</label>
                                    <div className="d-flex">
                                        <div className="form-check ms-2 me-4">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="seating_type"
                                                id="seating_indoor"
                                                value="Indoor"
                                                checked={BookingDetail.seating_type === 'Indoor'}
                                                onChange={handleInputChange}
                                                disabled={indoorAvailability === 0}
                                            />
                                            <label className="form-check-label" htmlFor="seating_indoor">
                                                Indoor {indoorAvailability === 0 && <span className="text-danger">(Full)</span>}
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="seating_type"
                                                id="seating_outdoor"
                                                value="Outdoor"
                                                checked={BookingDetail.seating_type === 'Outdoor'}
                                                onChange={handleInputChange}
                                                disabled={outdoorAvailability === 0}
                                            />
                                            <label className="form-check-label" htmlFor="seating_outdoor">
                                                Outdoor {outdoorAvailability === 0 && <span className="text-danger">(Full)</span>}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12"><hr /></div>
                            <div className="col-lg-4">
                                <div className="form_box">
                                    <label htmlFor="">Select Date</label>
                                    <DatePicker
                                        dateFormat="dd-MM-yyyy"
                                        selected={startDate}
                                        minDate={new Date()}
                                        maxDate={addMonths(new Date(), 6)}
                                        onChange={setDate}
                                        className="input_text"
                                        placeholderText="Select Date"
                                    />
                                    {simpleValidator.current.message('date', BookingDetail.date, 'required')}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="form_box">
                                    <label htmlFor="">Start Time</label>
                                    <select name="time" value={BookingDetail.time} onChange={handleInputChange} className="input_text">
                                        <option value="">Select Time</option>
                                        {timeList && Object.entries(timeList).map(([key, date]) => {
                                            return (<option value={date.time} key={key}>{date.time}</option>);
                                        })}
                                    </select>
                                    {simpleValidator.current.message('time', BookingDetail.time, 'required')}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="form_box">
                                    <label htmlFor="">Party Size</label>
                                    <select name="number_of_people" value={BookingDetail.number_of_people} onChange={handleInputChange} className="input_text">
                                        <option value=''>Select Party Size</option>
                                        {Array.from(Array(PartySize), (e, i) => {
                                            return (<option value={++i}>{i}</option>)
                                        })}
                                    </select>
                                    {simpleValidator.current.message('number of people', BookingDetail.number_of_people, 'required')}
                                </div>
                            </div>
                            <div className="col-lg-12"><hr /></div>
                            <div className="col-lg-4">
                                <div className="form_box">
                                    <label htmlFor="">First Name</label>
                                    <input type="text" name="first_name" value={BookingDetail.first_name} onChange={handleInputChange} className="input_text" placeholder="Your First Name" />
                                    {simpleValidator.current.message('first name', BookingDetail.first_name, 'required')}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="form_box">
                                    <label htmlFor="">Last Name</label>
                                    <input type="text" name="last_name" value={BookingDetail.last_name} onChange={handleInputChange} className="input_text" placeholder="Your Last Name" />
                                    {simpleValidator.current.message('last name', BookingDetail.last_name, 'required')}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="form_box">
                                    <label htmlFor="">Phone</label>
                                    <input type="text" name="phone_number" maxLength={12} value={BookingDetail.phone_number} onChange={handleInputChange} className="input_text" placeholder="Your Phone Number" />
                                    {simpleValidator.current.message('phone number', BookingDetail.phone_number, 'required|phone')}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="form_box">
                                    <label htmlFor="">Post Code</label>
                                    <input type="text" name="post_code" value={BookingDetail.post_code} onChange={handleInputChange} className="input_text" placeholder="Your Post Code" />
                                    {simpleValidator.current.message('post code', BookingDetail.post_code, 'required')}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="form_box">
                                    <label htmlFor="">Email</label>
                                    <input type="text" name="email" value={BookingDetail.email} onChange={handleInputChange} className="input_text" placeholder="Your Email Address" />
                                    {simpleValidator.current.message('email', BookingDetail.email, 'required|email')}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="form_box">
                                    <label htmlFor="">Request/Occasion</label>
                                    <input type="text" name="note" value={BookingDetail.note} onChange={handleInputChange} className="input_text" placeholder="Your Note" />
                                </div>
                            </div>
                            {parseInt(BookingDetail.number_of_people) >= minimum_person_save_card_details && <div className="col-lg-12">
                                <div className="mt-4 ">
                                    <div className="checkrow">
                                        <input type="checkbox" name="tc" checked={BookingDetail.tc} onChange={handleInputChange} id="termsandcondition1" />
                                        <label htmlhtmlFor="termsandcondition1">Terms and Conditions - Cancellation Policy  <a href="javascript:;" onClick={() => { (ShowTc) ? SetShowTc(false) : SetShowTc(true) }} style={{ 'float': 'right' }}>View Terms</a></label>
                                        {ShowTc && <div>
                                            <p className="p_note" style={{ 'textAlign': 'left' }}>At this restaurant, a credit card is required to hold tables for parties of 5 or more. Please note, if you are group of 5 or more we require $20 per person deposit for confirmation of booking(It can be returned or taken out from your final bill). If you cancel, reduce the group size or fail to show up within a 48 hour notice your deposit won’t be returned.</p>
                                        </div>}
                                    </div>
                                </div>
                            </div>} */}
                            <div className="col-lg-5 mx-auto">
                                <div className="btnbox form_box">
                                    <Link
                                        to="/"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowBookingWidget(true);
                                        }}
                                        className="ondabtn greenbtn bigbtn"
                                        >
                                        <img src="/assets/images/book_table_icon.svg" alt="" />
                                        Richmond
                                    </Link>
                                    {/* <button type="submit" disabled={ButtonDisabled} className="ondabtn bigbtn greenbtn" >{ButtonDisabled && <i className="spinner"></i>} Make Reservation</button> */}
                                </div>
                            </div>
                            <div className="col-lg-5 mx-auto">
                                <div className="btnbox form_box">
                                    <a
                                        href="https://www.opentable.com.au/r/onda-fitzroy-reservations-fitzroy?restref=311780&lang=en-AU&ot_source=Restaurant%20website"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ondabtn greenbtn bigbtn"
                                        >
                                        <img src="/assets/images/book_table_icon.svg" alt="" />
                                        Fitzroy
                                    </a>
                                    {/* <button type="submit" disabled={ButtonDisabled} className="ondabtn bigbtn greenbtn" >{ButtonDisabled && <i className="spinner"></i>} Make Reservation</button> */}
                                </div>
                            </div>
                        </div>
                    </form>
                    <p className="p_note">Please note Saturdays and Sundays incur a 10% Weekend Surcharge. Public Holidays incur a 15% Surcharge.</p>
                    <p className="p_note mt-1">Your Friday/Saturday reservation is for a dining time of 1 hour and 45 minutes</p>
                    {/* <p className="p_note mt-1">Groups of 6 or more must select our feed me menus</p> */}
                    <div className="payment_note"><strong>Payments:</strong> VISA, MasterCard, Cash, Apple Pay, Android Pay, Debit</div>
                </div>
            </div>
        </div>
        <StripeCheckout2
            className="btn btn-success StripeCheckout2 none"
            stripeKey={process.env.REACT_APP_STRIPE_KEY}
            token={handleToken}
            email={BookingDetail.email}
            currency={process.env.REACT_APP_CURRENCY}
            amount={0}
            name={'We dont charge your card'}
            panelLabel="Make Reservation"
            billingAddress={false}
            alipay={false}
        />
        {showBookingWidget && (
        <div className="widget-modal-overlay">
          <div className="widget-modal-content">
            <button
              className="widget-modal-close"
              onClick={() => setShowBookingWidget(false)}
              aria-label="Close modal"
            >
              {/* Use the v4 component */}
              <Close />
            </button>
            <OpenTableWidget />
          </div>
        </div>
      )}
    </>)
}
